import React from "react";
import "containers/Account/Info/Account.css";
import "containers/Account/MyChildren/MyChildren.css";
import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import { Container } from "@material-ui/core";
import CustomInput from "components/General/Form/CustomInput";
import CustomGenderRadio from "components/General/Form/CustomGenderRadio";
import CustomSelect from "components/General/Form/CustomSelect";
import ProfileDivider from "components/Account/Profile/ProfileDivider";
import TextArea from "components/General/Form/TextArea";
import * as ProfileHelper from "components/Account/Profile/ProfileHelper";
import ProfileCategoryGrid from "components/Account/Profile/ProjectCategoryGrid";
import CustomCheckbox from "components/General/Form/CustomCheckbox";
import VisibilityRadio from "components/General/Form/CustomVisibilityRadioButton";
import * as CONSTANT from "constants/text";
import AxiosConfig from "axiosConfig";
import CustomDatepicker from "components/General/Form/CustomDatepicker";
import UpdatePassword from "./UpdatePassword";
import TextTheme from "../../General/Text/TextTheme";

class ProfileForm extends React.Component {
  state = {
    projectCat: [],
    showModal: false,
    pageSuccess: false,
  };

  componentDidMount() {
    ProfileHelper.getCategory(this);
  }

  onChangePassword() {
    this.closeModal();
  }

  closeModal() {
    this.setState({
      showModal: !this.state.showModal,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      pageSuccess: false,
    });
  }
  onChangePasswordClicked() {
    const { oldPassword, newPassword, confirmNewPassword } = this.state;
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if (oldPassword === "" || oldPassword === undefined) {
      this.setState({
        pageError: "Current Password can not be blank",
      });
    } else if (
      newPassword === "" ||
      newPassword === undefined ||
      !newPassword.match(passwordRegex)
    ) {
      this.setState({
        pageError: CONSTANT.INVALID_PASSWORD,
      });
    } else if (newPassword !== confirmNewPassword) {
      this.setState({
        pageError: CONSTANT.INVALID_PASSWORD_MATCH,
      });
    } else if (oldPassword === newPassword) {
      this.setState({
        pageError: "Current password and new password can not be same",
      });
    } else {
      this.setState({
        pageError: "",
      });
      let formData = this.baseFormData();
      AxiosConfig.put("account/change_password/", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.data.status === "success")
            this.setState({
              pageSuccess: !this.state.pageSuccess,
              pageError: "",
            });
          setTimeout(() => {
            window.location.assign("/logout");
          }, 1500);
        })
        .catch(
          this.setState({
            pageError: "Please make sure your current password is correct",
          })
        );
    }
  }
  baseFormData() {
    let formData = new FormData();
    formData.append("oldPassword", this.state.oldPassword);
    formData.append("newPassword", this.state.newPassword);
    formData.append("confirmNewPassword", this.state.confirmNewPassword);
    return formData;
  }

  render() {
    return (
      <div style={{ display: "block" }}>
        <Container>
          <form
            id="child-form"
            onSubmit={this.props.onSaveClicked.bind(this)}
            className="account-form"
          >
            <div>
              <div className="cover-pic-form">               
                <div
                  className="cover-image"
                  style={{
                    backgroundImage: `url(${
                      this.props.coverPic || MyDefaultCoverPhoto
                    })`,
                  }}
                ></div>
                <label
                  className="mt-15 upload-photo"
                  htmlFor="cover_photo"
                  style={{ cursor: "pointer", marginBottom: "3px" }}
                >
                  Upload Cover Photo
                  <input
                    id="cover_photo"
                    style={{ display: "none" }}
                    type="file"
                    name="coverPic"
                    accept=".png, .jpeg, .jpg"
                    onChange={this.props.onCoverImageChange.bind(this)}
                  />
                </label>
                {this.props.coverPicError !== "" ? (
                  <TextTheme
                    message={this.props.coverPicError}
                    className="text_small text_red"
                  />
                ) : null}
              </div>
              <div className="blessing-form">
                <img
                  className="profile-picture"
                  src={this.props.profilePic || UploadPhoto}
                  alt=""
                />
                <label
                  className="upload-photo"
                  htmlFor="profile_photo"
                  style={{ cursor: "pointer", marginBottom: "3px" }}
                >
                  Upload Profile Photo
                  <input
                    id="profile_photo"
                    style={{ display: "none" }}
                    type="file"
                    name="profilePic"
                    accept=".png, .jpeg, .jpg"
                    onChange={this.props.onImageChange.bind(this)}
                  />
                </label>
                {this.props.profilePicError !=="" ? (
                  <TextTheme
                    message={this.props.profilePicError}
                    className="text_small text_red"
                  />
                ) : null}
              </div>
              <br />

              {this.props.userType === "adult" && this.props.email ? (
                <CustomInput
                  orientation="labeled"
                  label={CONSTANT.EMAIL_COLON}
                  value={this.props.email}
                  readOnly
                />
              ) : null}

              <CustomInput
                orientation="labeled"
                name="fullName"
                placeholder={CONSTANT.FULL_NAME}
                label={CONSTANT.NAME_COLON}
                value={this.props.fullName}
                handleChange={this.props.onDataChange.bind(this)}
                error={
                  this.props.errorMap.has("fullNameError")
                    ? this.props.errorMap.get("fullNameError")
                    : ""
                }
                required
              />
              {!this.props.onboarding ? (
                <div className="change-pass">
                  <p>Do you want to change your password?</p>
                  <ul className="list-inline">
                    <li
                      onClick={this.onChangePassword.bind(this, "Yes")}
                      className="yes"
                    >
                      Yes
                    </li>
                  </ul>
                </div>
              ) : null}
              {this.props.onboarding ? (
                <CustomInput
                  orientation="labeled"
                  name="username"
                  placeholder={CONSTANT.USERNAME}
                  label={CONSTANT.USERNAME_COLON}
                  value={this.props.username}
                  handleChange={this.props.onDataChange.bind(this)}
                  error={
                    this.props.errorMap.has("usernameError")
                      ? this.props.errorMap.get("usernameError")
                      : ""
                  }
                  required
                />
              ) : null}

              {this.props.onboarding ? (
                <CustomInput
                  orientation="labeled"
                  name="password"
                  type="password"
                  placeholder={CONSTANT.PASSWORD}
                  label={CONSTANT.PASSWORD_COLON}
                  value={this.props.password}
                  handleChange={this.props.onDataChange.bind(this)}
                  error={
                    this.props.errorMap.has("passwordError")
                      ? this.props.errorMap.get("passwordError")
                      : ""
                  }
                  required
                />
              ) : null}

              {this.props.onboarding ? (
                <CustomInput
                  orientation="labeled"
                  name="confirmPassword"
                  type="password"
                  placeholder={CONSTANT.CONFIRM_PASSWORD}
                  label={CONSTANT.CONFIRM_PASSWORD_COLON}
                  value={this.props.confirmPassword}
                  handleChange={this.props.onDataChange.bind(this)}
                  error={
                    this.props.errorMap.has("confirmPasswordError")
                      ? this.props.errorMap.get("confirmPasswordError")
                      : ""
                  }
                  required
                />
              ) : null}

              <ProfileDivider divider text="Personal Details" />

              {this.props.onboarding ? null : (
                <CustomInput
                  orientation="labeled"
                  name="address"
                  placeholder={CONSTANT.ADDRESS}
                  label={CONSTANT.ADDRESS_COLON}
                  value={this.props.address}
                  handleChange={this.props.onDataChange.bind(this)}
                />
              )}

              {this.props.onboarding ? null : (
                <CustomInput
                  orientation="labeled"
                  name="mobile"
                  placeholder={CONSTANT.MOBILE}
                  label={CONSTANT.MOBILE_COLON}
                  value={this.props.mobile}
                  handleChange={this.props.onDataChange.bind(this)}
                  error={
                    this.props.errorMap.has("mobError")
                      ? this.props.errorMap.get("mobError")
                      : ""
                  }
                />
              )}

              <CustomDatepicker
                orientation="labeled"
                name="dob"
                label={CONSTANT.BIRTH_DATE_COLON}
                value={
                  this.props.isMyAccount
                    ? this.props.formatted_dob
                    : this.props.dob
                }
                handleChange={this.props.onDataChange.bind(this)}
                error={
                  this.props.errorMap.has("dobError")
                    ? this.props.errorMap.get("dobError")
                    : ""
                }
                placeholder="MM/DD/YYYY"
                readOnly={this.props.isMyAccount ? "readOnly" : false}
              />

              <CustomGenderRadio
                gender={this.props.gender}
                handleChange={this.props.onDataChange.bind(this)}
                error={
                  this.props.errorMap.has("genderError")
                    ? this.props.errorMap.get("genderError")
                    : ""
                }
              />

              {this.props.userType === "child" ? (
                <CustomInput
                  orientation="labeled"
                  name="school"
                  label={CONSTANT.SCHOOL_COLON}
                  placeholder={CONSTANT.SCHOOL_NAME}
                  value={this.props.school}
                  handleChange={this.props.onDataChange.bind(this)}
                />
              ) : null}

              {this.props.userType === "child" ? (
                <CustomSelect
                  orientation="labeled"
                  name="schoolGrade"
                  title={CONSTANT.SCHOOL_GRADE_COLON}
                  placeholder={CONSTANT.SELECT_GRADE}
                  value={this.props.schoolGrade}
                  handleChange={this.props.onDataChange.bind(this)}
                  options={[
                    "Kindergarten",
                    "Grade 1",
                    "Grade 2",
                    "Grade 3",
                    "Grade 4",
                    "Grade 5",
                    "Grade 6",
                  ]}
                />
              ) : null}
              <div>
                {this.props.canEditVisibility ? (
                  <div>
                    <ProfileDivider divider text="Account Settings" />
                    <VisibilityRadio
                      title={"Profile Visibility"}
                      name={"profileVisibility"}
                      handleChange={this.props.onDataChange.bind(this)}
                      visibility={this.props.profileVisibility}
                    />
                    {this.props.hasChildren === "true" ? (
                      <VisibilityRadio
                        title="Children Profile Visibility"
                        name={"childrenProfileVisibility"}
                        handleChange={this.props.onDataChange.bind(this)}
                        visibility={this.props.childrenProfileVisibility}
                      />
                    ) : null}
                  </div>
                ) : null}
              </div>
              {this.props.onboarding ? null : (
                <div>
                  <ProfileDivider divider text="The Believer" />

                  <TextArea
                    title={CONSTANT.ABOUT_ME}
                    rows="6"
                    placeholder={CONSTANT.TELL_ABOUT_YOU}
                    name="aboutMe"
                    value={this.props.aboutMe}
                    handleChange={this.props.onDataChange.bind(this)}
                  />

                  <TextArea
                    title={CONSTANT.MY_FAVORITE_THINGS}
                    rows="6"
                    placeholder={CONSTANT.TELL_MAKES_YOU_SMILE}
                    name="favoriteThing"
                    value={this.props.favoriteThing}
                    handleChange={this.props.onDataChange.bind(this)}
                  />

                  <ProfileDivider divider text="The Dream" />

                  <TextArea
                    title="Dream"
                    rows="6"
                    placeholder={CONSTANT.MY_DREAM}
                    name="dream"
                    value={this.props.dream}
                    handleChange={this.props.onDataChange.bind(this)}
                  />

                  <TextArea
                    title={CONSTANT.HEROES}
                    rows="6"
                    placeholder={CONSTANT.YOUR_HEROES}
                    name="heroes"
                    value={this.props.heroes}
                    handleChange={this.props.onDataChange.bind(this)}
                  />

                  <ProfileDivider divider text={CONSTANT.THE_SUPERPOWERS} />

                  <TextArea
                    title={CONSTANT.MY_SUPERPOWERS}
                    rows="6"
                    placeholder={CONSTANT.TELL_YOUR_POWERS}
                    name="superPowers"
                    value={this.props.superPowers}
                    handleChange={this.props.onDataChange.bind(this)}
                  />

                  <ProfileDivider divider text={CONSTANT.THE_CAUSES} />
                  <ProfileCategoryGrid
                    projectCat={this.state.projectCat}
                    handleChange={this.props.onProjectInterestDataChange.bind(
                      this
                    )}
                    selectedOptions={this.props.projectInterest}
                  />

                  <TextArea
                    title={CONSTANT.FAVORITE_CAUSES}
                    rows="6"
                    placeholder={CONSTANT.NAME_YOUR_CAUSES}
                    name="cause"
                    value={this.props.cause}
                    handleChange={this.props.onDataChange.bind(this)}
                  />
                </div>
              )}
              {this.props.onboarding ? (
                <div className="family-account">
                  <CustomCheckbox
                    name="isTermsPrivacy"
                    defaultChecked={this.props.isTermsPrivacy}
                    handleChange={this.props.onCheckboxChange.bind(this)}
                    text={CONSTANT.ACCEPT_TOS_PRIVACY}
                    error={
                      this.props.errorMap.has("isTermsPrivacyError")
                        ? this.props.errorMap.get("isTermsPrivacyError")
                        : ""
                    }
                  />

                  <CustomCheckbox
                    name="isMinorClause"
                    defaultChecked={this.props.isMinorClause}
                    handleChange={this.props.onCheckboxChange.bind(this)}
                    text={CONSTANT.AFFIRM_GUARDIAN_DUTY}
                    error={
                      this.props.errorMap.has("isMinorClauseError")
                        ? this.props.errorMap.get("isMinorClauseError")
                        : ""
                    }
                  />
                  <CustomCheckbox
                    name="isConsentSharing"
                    defaultChecked={this.props.isConsentSharing}
                    handleChange={this.props.onCheckboxChange.bind(this)}
                    text={CONSTANT.CONSENT_CONTENT_SHARING}
                    error={
                      this.props.errorMap.has("isConsentSharingError")
                        ? this.props.errorMap.get("isConsentSharingError")
                        : ""
                    }
                  />
                  <CustomCheckbox
                    name="isFeePay"
                    defaultChecked={this.props.isFeePay}
                    handleChange={this.props.onCheckboxChange.bind(this)}
                    text={CONSTANT.PAY_CONSENT_FEE}
                    error={
                      this.props.errorMap.has("isFeePayError")
                        ? this.props.errorMap.get("isFeePayError")
                        : ""
                    }
                  />
                </div>
              ) : null}
            </div>
          </form>
          <UpdatePassword
            showModal={this.state.showModal}
            closeModal={this.closeModal.bind(this)}
            pageSuccess={this.state.pageSuccess}
            onChangePasswordClicked={this.onChangePasswordClicked.bind(this)}
            confirmNewPassword={this.state.confirmNewPassword}
            oldPassword={this.state.oldPassword}
            newPassword={this.state.newPassword}
            pageError={this.state.pageError}
            onDataChange={ProfileHelper.onDataChange.bind(this)}
          />
        </Container>
      </div>
    );
  }
}

export default ProfileForm;
